module.exports = __webpack_public_path__ + "img/img1.f32da8e2.png";